module.exports = __webpack_public_path__ + "static/media/trash.40dbf17a.svg";